const historyContent = {
  title: '연혁 관리 매뉴얼',
  content: `
  <div class="page-title">[연혁 관리]</div>

# [개요]
연혁 관리 기능은 웹사이트의 주요 이력과 발자취를 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **연혁의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 연혁 조회 | 등록된 연혁 목록 확인 및 검색 | 관리자 |
| 연혁 등록 | 신규 연혁 생성 및 설정 | 관리자 |
| 연혁 수정 | 기존 연혁 정보 수정 | 관리자 |

# [조회]
등록된 연혁의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 목록 영역 | 연혁 목록 테이블 | • 날짜순 정렬<br>• 언어별 제목 확인<br>• 사용 여부 상태 |
| 버튼 영역 | 등록 버튼 | • 신규 연혁 등록 |

![연혁 목록](/assets/images/guide/history/list.png)

# [등록/수정]
연혁을 신규 등록하거나 기존 연혁의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 날짜와 제목(한국어)은 필수 입력 항목입니다.
> - 등록된 연혁은 날짜 기준으로 자동 정렬됩니다.
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 설정 | • 날짜<br>• 사용 여부 | • 연혁 일자<br>• 노출 여부 설정 |
| 다국어 설정 | • 언어별 제목<br>• 언어별 콘텐츠 | • 각 언어별 제목 입력<br>• 각 언어별 상세 내용 입력 |

> 💡 **Tip**
> - 모든 언어의 제목과 콘텐츠를 한 번에 입력하고 저장할 수 있습니다.
> - 사용 여부 설정으로 임시 저장 후 추후 노출이 가능합니다.

![연혁 등록/수정](/assets/images/guide/history/edit.png)
  `,
};

export default historyContent;
